enum ActionTypes {
  DIRECT_ACCESS_FETCH_COURSE_VERSIONS = 'DIRECT_ACCESS_FETCH_COURSE_VERSIONS',
  DIRECT_ACCESS_FETCH_COURSE = 'DIRECT_ACCESS_FETCH_COURSE',
  DIRECT_ACCESS_FETCH_MENU = 'DIRECT_ACCESS_FETCH_MENU',
  DIRECT_ACCESS_FETCH_MATERIAL = 'DIRECT_ACCESS_FETCH_MATERIAL',
}

export default ActionTypes;
